const STORAGE_PREFIX = 'health_commission_'

export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER_INFO: 'user_info',
  EXAM_NOTICE: 'exam_notice',
  EXAM_DURATION: 'exam_duration',
  EXAM_START_TIME: 'exam_start_time'
}

function getKey(key) {
  return STORAGE_PREFIX + key
}

export function getStorageItem(key, defaultValue = '') {
  try {
    const value = localStorage.getItem(getKey(key))
    return value === null ? defaultValue : value
  } catch (error) {
    return defaultValue
  }
}

export function setStorageItem(key, value) {
  try {
    localStorage.setItem(getKey(key), value)
  } catch (error) {
    console.error('storage set error', error)
  }
}

export function removeStorageItem(key) {
  try {
    localStorage.removeItem(getKey(key))
  } catch (error) {
    console.error('storage remove error', error)
  }
}

export function getStorageJSON(key, defaultValue = {}) {
  const raw = getStorageItem(key, '')
  if (!raw) {
    return defaultValue
  }
  try {
    return JSON.parse(raw)
  } catch (error) {
    return defaultValue
  }
}

export function setStorageJSON(key, data) {
  setStorageItem(key, JSON.stringify(data))
}

export function getStorageNumber(key, defaultValue = 0) {
  const raw = getStorageItem(key, '')
  if (!raw) {
    return defaultValue
  }
  const num = Number(raw)
  return Number.isNaN(num) ? defaultValue : num
}

export function setStorageNumber(key, value) {
  setStorageItem(key, String(value))
}

// 兼容旧版 sessionStorage / 无前缀 localStorage 数据
export function migrateLegacyStorage() {
  const legacySessionKeys = [
    STORAGE_KEYS.USER_INFO,
    STORAGE_KEYS.EXAM_NOTICE,
    STORAGE_KEYS.EXAM_DURATION,
    STORAGE_KEYS.EXAM_START_TIME
  ]

  legacySessionKeys.forEach((key) => {
    const legacyValue = sessionStorage.getItem(key)
    if (legacyValue !== null && !getStorageItem(key)) {
      setStorageItem(key, legacyValue)
    }
    sessionStorage.removeItem(key)
  })

  const legacyToken = localStorage.getItem('token')
  if (legacyToken && !getStorageItem(STORAGE_KEYS.TOKEN)) {
    setStorageItem(STORAGE_KEYS.TOKEN, legacyToken)
  }
  localStorage.removeItem('token')
}
